<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-table
        title="Doadores"
        :data="$store.state.listUpload"
        :columns="columns"
        row-key="id"
        :visible-columns="visibleColumns"
        :pagination.sync="pagination"
        :filter="filter"
        :loading="$store.state.loading"
      >
        <template v-slot:top="props">
          <div class="col-4 q-table__title">Boletos</div>
          <div class="col-4 ">
            <q-input borderless dense debounce="300" input-class="inputSearch" v-model="filter" placeholder="Buscar">
              <template v-slot:append>
                <q-icon class="text-white" name="search"></q-icon>
              </template>
            </q-input>
          </div>
          <div class="col-3 ">
            <q-select
              v-model="visibleColumns"
              multiple
              borderless
              dense
              options-dense
              emit-value
              map-options
              :display-value="'Colunas visíveis'"
              :options="columns"
              option-value="name"
              style="min-width: 150px"
            ></q-select>
          </div>
          <div class="col-1 ">
            <q-btn color="bg-purple-10" outline icon="add" @click="openDialog = true"></q-btn>
          </div>

        </template>

        <template v-slot:body-cell-boleto_dda="value">
          <q-td>
            <q-chip square color="teal" text-color="white" v-if="value.value == '1'" label="Sim"/>
            <q-chip square color="yellow-5" text-color="black" v-if="value.value == '0' || value.value == ''"
                    label="Não"/>
          </q-td>
        </template>
        <template v-slot:body-cell-options="value">
          <q-td>
            <q-btn round color="primary" icon="visibility">
            </q-btn>
          </q-td>
        </template>

      </q-table>

    </div>
    <q-dialog
      v-model="openDialog"
      transition-show="slide-up"
      transition-hide="slide-down"
      :maximized="maximizedToggle"
      content-style="{ backgroundColor: '#590A7F' }"
    >
      <q-card class="bg-purple-10 text-white">
        <q-card-section>
          <q-uploader
            :url="url"
            label="Arquivo de retorno de boleto itaú"
            :factory="uploadFactory"
            color="purple-10"
            accept=".RET"
            send-raw
            with-credentials
            :max-file-size="maxSize"
            :auto-upload="true"
            @uploaded="finished"
            @finish="finished"
          >

          </q-uploader>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="alertError">
      <q-card style="width: 300px">
        <q-card-section>
          <div class="text-h6">{{titleError}}</div>
        </q-card-section>

        <q-card-section>
          {{messageError}}
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="alertError = false"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>

</template>

<script>
import { UPLOAD_BOLETO_ITAU } from '../graphql/graphql'

export default {
  name: 'UploadItauBoleto',
  data () {
    return {
      openDialog: false,
      alertError: false,
      titleError: '',
      messageError: '',
      filter: '',
      maxSize: 10 * 1024 * 1024 * 1024,
      data: [],
      url: '',
      maximizedToggle: false,
      visibleColumns: [
        'agencia_cobradora',
        'codigo_banco',
        'uso_empresa',
        'nosso_numero1',
        'carteira',
        'codigo_ocorrencia',
        'data_ocorrencia',
        'numero_documento',
        'vencimento',
        'valor_titulo',
        'valor_principal',
        'data_credito',
        'boleto_dda',
        'nome_pagador',
        'codigo_liquidacao',
        'numero_sequencial',
        'mensagem'
      ],
      loading: true,
      columns: [
        {
          name: 'tipo_registro',
          label: 'Tipo de Registro',
          align: 'left',
          field: 'tipo_registro'
        }, {
          name: 'codigo_inscricao',
          label: 'Código de inscrição',
          align: 'left',
          field: 'codigo_inscricao'
        }, {
          name: 'numero_inscricao',
          label: 'Número de inscrição',
          align: 'left',
          field: 'numero_inscricao'
        }, {
          name: 'agencia',
          label: 'Agência',
          align: 'left',
          field: 'agencia'
        }, {
          name: 'zeros1',
          label: 'Zeros 1',
          align: 'left',
          field: 'zeros1'
        }, {
          name: 'conta',
          label: 'Conta',
          align: 'left',
          field: 'conta'
        }, {
          name: 'dac',
          label: 'DAC',
          align: 'left',
          field: 'dac'
        }, {
          name: 'brancos1',
          label: 'Brancos 1',
          align: 'left',
          field: 'brancos1'
        }, {
          name: 'uso_empresa',
          label: 'Uso da empresa',
          align: 'left',
          field: 'uso_empresa'
        }, {
          name: 'nosso_numero1',
          label: 'Nosso número',
          align: 'left',
          field: 'nosso_numero1'
        }, {
          name: 'brancos2',
          label: 'Brancos 2',
          align: 'left',
          field: 'brancos2'
        }, {
          name: 'carteira',
          label: 'Carteira',
          align: 'left',
          field: 'carteira'
        }, {
          name: 'nosso_numero2',
          label: 'Nosso número 2',
          align: 'left',
          field: 'nosso_numero2'
        }, {
          name: 'dac_nosso_numero',
          label: 'DAC nosso número',
          align: 'left',
          field: 'dac_nosso_numero'
        }, {
          name: 'brancos3',
          label: 'Brancos 3',
          align: 'left',
          field: 'brancos3'
        }, {
          name: 'carteira2',
          label: 'Carteira 2',
          align: 'left',
          field: 'carteira2'
        }, {
          name: 'codigo_ocorrencia',
          label: 'Código ocorrência',
          align: 'left',
          field: 'codigo_ocorrencia'
        }, {
          name: 'data_ocorrencia',
          label: 'Data de ocorrência',
          align: 'left',
          field: 'data_ocorrencia'
        }, {
          name: 'numero_documento',
          label: 'Número documento',
          align: 'left',
          field: 'numero_documento'
        }, {
          name: 'nosso_numero3',
          label: 'Nosso número 3',
          align: 'left',
          field: 'nosso_numero3'
        }, {
          name: 'brancos4',
          label: 'Brancos 4',
          align: 'left',
          field: 'brancos4'
        }, {
          name: 'vencimento',
          label: 'Vencimento',
          align: 'left',
          field: 'vencimento'
        }, {
          name: 'valor_titulo',
          label: 'Valor título',
          align: 'left',

          field: 'valor_titulo'
        }, {
          name: 'codigo_banco',
          label: 'Código banco',
          align: 'left',
          field: 'codigo_banco'
        }, {
          name: 'agencia_cobradora',
          label: 'Agência cobradora',
          align: 'left',
          field: 'agencia_cobradora'
        }, {
          name: 'dac_agencia_cobradora',
          label: 'DAC agência cobradora',
          align: 'left',
          field: 'dac_agencia_cobradora'
        }, {
          name: 'especie',
          label: 'Espécie',
          align: 'left',
          field: 'especie'
        }, {
          name: 'tarifa_cobranca',
          label: 'Tarifa de cobrança',
          align: 'left',
          field: 'tarifa_cobranca'
        }, {
          name: 'brancos5',
          label: 'Brancos 5',
          align: 'left',
          field: 'brancos5'
        }, {
          name: 'valor_iof',
          label: 'Valor iof',
          align: 'left',
          field: 'valor_iof'
        }, {
          name: 'valor_abatimento',
          label: 'Valor abatimento',
          align: 'left',
          field: 'valor_abatimento'
        }, {
          name: 'descontos',
          label: 'Descontos',
          align: 'left',
          field: 'descontos'
        }, {
          name: 'valor_principal',
          label: 'Valor principal',
          align: 'left',
          field: 'valor_principal'
        }, {
          name: 'juros',
          label: 'Juros',
          align: 'left',
          field: 'juros'
        }, {
          name: 'outros_creditos',
          label: 'Outros créditos',
          align: 'left',
          field: 'outros_creditos'
        }, {
          name: 'boleto_dda',
          label: 'Boleto DDA',
          align: 'left',
          field: 'boleto_dda'
        }, {
          name: 'brancos6',
          label: 'Brancos 6',
          align: 'left',
          field: 'brancos6'
        }, {
          name: 'data_credito',
          label: 'Data de crédito',
          align: 'left',
          field: 'data_credito'
        }, {
          name: 'instrucao_cancelada',
          label: 'Instrução cancelada',
          align: 'left',
          field: 'instrucao_cancelada'
        }, {
          name: 'brancos7',
          label: 'Brancos 7',
          align: 'left',
          field: 'brancos7'
        }, {
          name: 'zeros2',
          label: 'Zeros 2',
          align: 'left',
          field: 'zeros2'
        }, {
          name: 'nome_pagador',
          label: 'Doador',
          align: 'left',
          field: 'nome_pagador'
        }, {
          name: 'brancos8',
          label: 'Brancos 8',
          align: 'left',
          field: 'brancos8'
        }, {
          name: 'erros',
          label: 'Erros',
          align: 'left',
          field: 'erros'
        }, {
          name: 'brancos9',
          label: 'Brancos 9',
          align: 'left',
          field: 'brancos9'
        }, {
          name: 'codigo_liquidacao',
          label: 'código liquidação',
          align: 'left',
          field: 'codigo_liquidacao'
        }, {
          name: 'numero_sequencial',
          label: 'Número sequencial',
          align: 'left',
          field: 'numero_sequencial'
        }, {
          name: 'mensagem',
          label: 'Mensagem',
          align: 'left',
          field: 'mensagem'
        }
      ],
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 0
      }
    }
  },
  methods: {
    uploadFactory (file) {
      console.log(file)
      this.$store.dispatch('setLoading')
      return (

        this.$apollo.mutate({
          mutation: UPLOAD_BOLETO_ITAU,
          variables: { file: file[0] },
          context: {
            hasUpload: true
          },
          update: (store, data) => {
            this.$store.dispatch('toList', data.data.uploadBoletoItau)
            this.pagination.rowsNumber = data.data.uploadBoletoItau.length
          }
        })
          .catch(error => {
            console.error(error)
            const errors = { error }
            this.alertError = true
            this.titleError = errors.error.graphQLErrors[0].message
            this.messageError = errors.error.graphQLErrors[0].debugMessage
            console.error(errors.error.graphQLErrors[0].trace[0])
          })

      )
      // return new Promise(resolve, reject);
    },
    finished () {
      this.$store.dispatch('setLoading')
      this.openDialog = false
    }
  },
  mounted () {
    this.$store.dispatch('toList', [])
  }
}
</script>
<style>
  input[type='text'].inputSearch {
    color: white !important;
  }
</style>
